import React from 'react';
import { queries } from '../../graphql/graphql';
import { Card, Col, Row, Image } from 'antd';
import { Link } from 'react-router';
import ListContainer, { ListItem } from '../../components/containers/AdminList';

const imageStyle: React.CSSProperties = {
  aspectRatio: '1 / 1',
  objectFit: 'cover',
  width: '100%',
};
interface CustomCardProps {
  item: ListItem;
  refetch: () => void;
  prefix: string;
  roles?: string[];
}

const CustomCard: React.FC<CustomCardProps> = ({ item }) => {
  const getActions = (item: ListItem) => {
    return [
      <Link key={`link-${item.id}`} to={`/site-visit/${item.id}`}>
        View
      </Link>,
      <Link key={`link-${item.id}`} to={`/site-visit/edit/${item.id}`}>
        Edit
      </Link>,
    ];
  };

  const preview = item.preview as { original?: string } | undefined;

  return (
    <Card
      hoverable
      cover={<Image preview={false} alt="" src={preview?.original} style={imageStyle} />}
      actions={getActions(item)}>
      <Card.Meta
        // title={(item.title || '').toUpperCase()}
        description={<p>{item.map?.address || 'Address is empty'}</p>}
        style={{ minHeight: 100 }}
      />
    </Card>
  );
};

const ListSiteVisit: React.FC = () => {
  return (
    <div
      style={{
        display: 'block',
        width: '100%',
        padding: '2em',
        textAlign: 'left',
      }}>
      <Row gutter={[16, 16]} style={{ height: '100%', width: '100%', margin: 0 }}>
        <Col span={24}>
          <ListContainer
            prefix="site-visit"
            query={queries.siteVisit.USER_SITE_VISIT_LIST}
            inline={false}
            editable={true}
            canCreate={true}
            adminView={false}
            CustomCard={CustomCard}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ListSiteVisit;
